import {
  Text,
  Graphics,
  filters,
  Sprite,
  WRAP_MODES,
  Container,
} from "pixi.js";
import { singleton } from "tsyringe";
import { PixiApp } from "../pixi-app";
import gsap from "gsap";
import { checkIsMobile } from "../utils/check-is-mobile";
import { TEXT_RESOLUTION } from "../config/texts";

const FILTER_SCALE = 150;
const FILTER_PAD = 100;
const TEXT_OFFSET = 100;
const TITLE_FONT_SIZE = 52;
const TITLE_FONT_SIZE_SM = 37;
const SUBTITLE_FONT_SIZE = 24;
const SUBTITLE_FONT_SIZE_SM = 18;

@singleton()
export class PreludeComponent {
  private text: Text;
  private subTitle: Text;
  private filter: any;
  private container = new Container();
  private textWidth = 0;
  private textHeight = 0;
  constructor(private pixiApp: PixiApp) {}
  mount() {
    this.pixiApp.stage.addChild(this.container);
    this.mountMainTitle();
    this.mountSubTitle();
  }
  play() {
    return new Promise((res) => {
      const ease = "Expo.easeOut";
      const easeOut = "Expo.easeOut";
      const duration = 2.5;
      const tl = gsap.timeline({ defaults: { duration, ease } });

      tl.to(this.filter.scale, { x: 0, y: 0 }, 0)
        .to(
          this.text,
          { x: this.text.x + TEXT_OFFSET, y: this.text.y + TEXT_OFFSET },
          0
        )
        .to(this.text, { ease: "linear", alpha: 1 }, "<+=0.05")
        .to(
          this.subTitle,
          { y: this.subTitle.y + this.subTitle.height },
          ">-1.5"
        )
        .to(
          this.filter.scale,
          {
            x: FILTER_SCALE,
            y: FILTER_SCALE,
            ease: easeOut,
            duration,
          },
          "out"
        )
        .to(
          this.text,
          {
            x: this.text.x + TEXT_OFFSET * 2,
            y: this.text.y + TEXT_OFFSET * 2,
            ease: easeOut,
            duration,
            onComplete: () => this.unmount(),
          },
          "out"
        )
        .to(
          this.text,
          {
            alpha: 0,
            ease: easeOut,
            duration: 0.75,
          },
          "out+=0.2"
        )
        .to(
          this.subTitle,
          {
            alpha: 0,
            ease: "linear",
            duration: 0.45,
            onComplete: res,
          },
          "out-=0.4"
        );
    });
  }
  private unmount = () => {
    this.pixiApp.stage.removeChild(this.container);
    this.container.destroy({ children: true });
    this.container = undefined;
    this.filter.destroy();
  };
  private mountMainTitle() {
    const isMobile = checkIsMobile();
    const { pixiApp } = this;
    const text = new Text("Oscar-Claude Monet", {
      fontFamily: "Playfair Display",
      fontWeight: "400",
      fontSize: isMobile ? TITLE_FONT_SIZE_SM : TITLE_FONT_SIZE,
      wordWrap: true,
      align: "center",
      wordWrapWidth: document.documentElement.clientWidth,
      fill: 0xffffff,
      lineHeight: 0,
    });
    text.resolution = TEXT_RESOLUTION;
    const filterSprite = new Sprite(pixiApp.loader.resources.textDisp.texture!);
    const filter = new filters.DisplacementFilter(filterSprite);
    filter.scale.y = FILTER_SCALE;
    filter.scale.x = FILTER_SCALE;
    this.filter = filter;
    filter.padding = FILTER_PAD;
    filterSprite.texture.baseTexture.wrapMode = WRAP_MODES.REPEAT;
    this.text = text;
    this.text.alpha = 0;
    this.textWidth = text.width;
    this.textHeight = text.height;
    text.x = pixiApp.screen.width / 2 - this.textWidth / 2;
    text.y = pixiApp.screen.height / 2 - this.textHeight / 2;
    text.y -= TEXT_OFFSET;
    text.x -= TEXT_OFFSET;
    text.filters = [filter];
    this.container.addChild(filterSprite);
    this.container.addChild(text);
  }
  private mountSubTitle() {
    const isMobile = checkIsMobile();
    const { pixiApp } = this;
    const text = new Text("1840(Paris) - 1926(Giverny)", {
      fontFamily: "Playfair Display",
      fontWeight: "400",
      fontSize: isMobile ? SUBTITLE_FONT_SIZE_SM : SUBTITLE_FONT_SIZE,
      wordWrap: true,
      align: "center",
      wordWrapWidth: document.documentElement.clientWidth,
      fill: 0xffffff,
      lineHeight: 0,
    });
    text.x = pixiApp.screen.width / 2 - text.width / 2;
    text.y = pixiApp.screen.height / 2 + this.textHeight - 30;
    const mask = new Graphics();
    mask.beginFill(0xffffff);
    mask.drawRect(text.x, text.y, text.width, text.height);
    text.y -= text.height;
    mask.endFill();
    text.mask = mask;
    this.container.addChild(mask);
    this.container.addChild(text);
    this.subTitle = text;
  }
}
